import AsyncStorage from '@react-native-async-storage/async-storage';

const LEGACY_DRAFT_PREFIXES = ['pos_active_draft_v1:', 'pos_parked_sale_v1:'];

export async function clearPosCartPersistenceForUser(userId: string): Promise<void> {
  const keys = await AsyncStorage.getAllKeys();
  const suffix = `:${userId}`;
  const toRemove = keys.filter(
    (key) => LEGACY_DRAFT_PREFIXES.some((prefix) => key.startsWith(prefix)) && key.endsWith(suffix),
  );
  if (toRemove.length > 0) {
    await AsyncStorage.multiRemove(toRemove);
  }
}
